// This can be expanded once we (maybe) add other / our own VR player
const CLIENT_TYPE = 'krpano';

class TrackerAnnounce {
	constructor(source) {
		/**
		 * One of TrackerSession.CLIENT_TYPES. Should be hardcoded inside the client
		 */
		this.client_type = CLIENT_TYPE;

		/**
		 * Version string of the running client app.
		 */
		this.client_version = undefined;

		/**
		 * Fingerprint to uniquely identify user's device. In browser, generated using browser fingerprinting techniques
		 */
		this.device_fingerprint = undefined;

		/**
		 * If available, provide a user id here. Arbitrary value that can be provided to the site from the outside.
		 */
		this.user_id = undefined;

		/**
		 * Source of the user_id. Can be something like "cookie" or "query".
		 */
		this.user_id_provider = undefined;

		/**
		 * Site ID in spinview app. On web, this is automatically provided by the server.
		 */
		this.site_id = undefined;

		/**
		 * Site version ID in spinview app. On web, this is automatically provided by the server.
		 */
		this.site_version_id = undefined;

		/**
		 * Alternate version to attach session to some site in the system. Can be used for testing
		 * or for tours that aren't hosted on the platform, for some reason.
		 */
		this.site_key = undefined;

		/**
		 * Whether the content is loaded inside iFrame. Web only.
		 */
		this.iframe = undefined;

		/**
		 * Referrer field of the link that led to the tour. Web only.
		 */
		this.referrer = undefined;

		/**
		 * Additional arbitrary tag. Should be used to identify how apps should handle custom_data (eg. client name)
		 */
		this.custom_tag = undefined;

		/**
		 * Additional blob of data to attach to this session. Can be used later for reports.
		 */
		this.custom_data = undefined;

		if (source) {
			Object.assign(this, source);
		}
	}
}

export default TrackerAnnounce;
